import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import ReactTooltip from "react-tooltip";
import Modal from '../../../Util/Modal/CustomModal';
import { useSelector, useDispatch } from 'react-redux';
import CustomForm from '../../../Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../Util/Form/CustomForm/CustomFormContainer';

import { VerifyPermission } from "../../../../../util/core/VerifyPermission";

function CustomListContainer(props) {
  const currentFunctionality = VerifyPermission();
  const defaultPropsForm = {
    labelTitle: 'Lista',
    labelTitleButtonAdd: 'Incluir novo item',
    canAdd: (currentFunctionality && currentFunctionality.canAdd) ? true : false,
    pathAdd: '',
    content: '',
    showInnerModal: props.showInnerModal ? props.showInnerModal : true
  }

  let list = { ...defaultPropsForm, ...props };
  if (props.canAdd) {
    list.canAdd = props.canAdd;
  }

  if (list.list) {
    list.list.key_data_rows = `custom_list_data_${props.list.endpoint}`;
    if (list.list.canAdd != undefined) {
      list.canAdd = list.list.canAdd;
    }
  }

  const navigate = useNavigate();
  const showModal = useSelector((state) => { return state.core.session.custom_form_show_modal });
  const modalContent = useSelector((state) => { return state.core.session.custom_form_content_modal });
  const dispatch = useDispatch();
  let [modalTitle, setModalTitle] = useState('');

  const onClickNew = () => {
    if (list.list && list.list.type == 'dialog') {
      const params = {
        labelTitle: props.form.labelTitleAdd,
        readOnly: false
      }

      let form = { ...props.form, ...params };

      setShowModal(true)
      setModalContent(
        <CustomFormContainer
          form={form}
          list={list.list}
          content={<CustomForm form={form} list={list.list} />}
        />
      );
    } else {
      navigate(list.pathAdd);
    }
  }

  const setShowModal = status => {
    dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_show_modal', value: status });
  }

  const setModalContent = content => {
    dispatch({ type: 'UPDATE_SESSION', key: 'custom_form_content_modal', value: content });
  }
  
  return (
    <>
      <Modal
        modalXXL={props.modalXXL}
        size='lg'
        show={showModal && list.showInnerModal}
        handleShow={() => setShowModal(true)}
        handleClose={() => setShowModal(false)}
        title={modalTitle}
        content={modalContent}
        showButtons={false}
        showHeader={false}
      />
      <section className="content" style={{ marginTop: '30px' }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {/* /.card */}
              <div className="card card-outline card-info">
                <div className="card-header">
                  <h3 className="card-title">{props.icon || <i className='fa-solid fa-pen-to-square mr-1'></i>}{list.labelTitle}</h3>
                  <div>
                    {list.canAdd && (
                      <a onClick={onClickNew} className="btn btn-primary float-right" data-tip data-for="registerTip">
                        {list?.labelTitleButtonAdd ? list.labelTitleButtonAdd : 'Novo'}
                      </a>
                    )}

                    <ReactTooltip id="registerTip" place="top" effect="solid">
                      {list.labelTitleButtonAdd}
                    </ReactTooltip>
                  </div>

                  {
                    props.buttons && props.buttons.filter((e) => e != undefined).map(button => {
                      return (
                        <div>
                          <a onClick={button.callback} className={`${button.class} float-right mr-2`} data-tip data-for={`button-${button.name}`}>
                            {button.icon && (
                              <i className={`${button.icon} mr-1`} />
                            )}
                            {button.label}
                          </a>
                          <ReactTooltip id={`button-${button.name}`} place="top" effect="solid">
                            {button.tooltipLabel}
                          </ReactTooltip>
                        </div>
                      )
                    })
                  }

                </div>
                {/* /.card-header */}
                {list.content}
                {/* /.card-body */}
              </div>
              {/* /.card */}
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container-fluid */}
      </section>
    </>
  );
}
export default CustomListContainer;